export default __webpack_public_path__ + "cd15a50226b21e497ba7c2080c384bb4.svg";